// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"43cc06fc","150":"55327159","186":"90b3c5c0","372":"e1ed732a","481":"53832e85","617":"1115d8db","736":"355103b9","787":"f309dd56","970":"fa776323"}[chunkId] + ".chunk.js";
};